import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar/Sidebar';
import Navbar from '../components/common/Navbar/Navbar';
import PocOwnerDashboard from '../pages/pocOwner/PocOwnerDashboard';
import PocOwnerProjects from '../pages/pocOwner/PocOwnerProjects';
import CompetitionMatcherAccess from '../pages/common/CompetitionMatcherAccess';
import PocOwnerReviewQueue from '../pages/pocOwner/PocOwnerReviewQueue';
import CompetitionSetup from '../pages/common/CompetitionSetup';
import CompetitionDeadlineWatch from '../pages/common/CompetitionDeadlineWatch';
import CompetitionWorkflow from '../pages/admin/CompetitionWorkflow';
import ProjectDetails from '../pages/common/ProjectDetails';
import styles from './Routes.module.css';

const PocOwnerRoutes = () => {
  const menuItems = [
    { label: 'Dashboard', path: '/poc-owner/dashboard', icon: 'dashboard' },
    { label: 'My Projects', path: '/poc-owner/projects', icon: 'projects' },
    { label: 'Competition Matcher', path: '/poc-owner/comp-matcher', icon: 'competitions' },
    { label: 'Competition Review', path: '/poc-owner/comp-review', icon: 'assignments' },
    { label: 'Competitions', path: '/poc-owner/competitions', icon: 'competitions' },
    { label: 'Competition Setup', path: '/poc-owner/competition-setup', icon: 'materials' },
    { label: 'Approaching Deadlines', path: '/poc-owner/comp-deadlines', icon: 'milestones' },
  ];

  return (
    <div className={styles.layout}>
      <Sidebar menuItems={menuItems} role="poc_owner" />
      <div className={styles.mainContent}>
        <Navbar title="COSMIC — Innovation Team" />
        <div className={styles.content}>
          <Routes>
            <Route path="dashboard" element={<PocOwnerDashboard />} />
            <Route path="projects" element={<PocOwnerProjects />} />
            <Route path="comp-matcher" element={<CompetitionMatcherAccess />} />
            <Route path="comp-review" element={<PocOwnerReviewQueue />} />
            <Route path="competitions" element={<CompetitionWorkflow />} />
            <Route path="competition-setup" element={<CompetitionSetup />} />
            <Route path="comp-deadlines" element={<CompetitionDeadlineWatch />} />
            <Route path="projects/:projectId" element={<ProjectDetails />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default PocOwnerRoutes;
